const Dimension = {
  CONTENT_CONTAINER_MAX_WIDTH: 1024,
} as const;

export default Dimension;
